import axios from 'axios';

import { Language } from '../../_translations/Language';
import { config } from '../../config';
import { Examination } from '../_models';

export async function fetchExercises() {
  const locale = Language.getLocale();
  return axios.get<Examination>(`${config.examinationApiHost()}exam/b/exercises-${locale}.json`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
}
